<template>
  <div>
    <div class="application2">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application2-1.jpg" alt />
          <img src="../../assets/images/application/application2-2.jpg" alt />
          <img src="../../assets/images/application/application2-3.jpg" alt />
          <img src="../../assets/images/application/application2-4.jpg" alt />
          <img src="../../assets/images/application/application2-5.jpg" alt />
          <img src="../../assets/images/application/application2-6.jpg" alt />
          <img src="../../assets/images/application/application2-7.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application2">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>智慧社区、智慧城管、城市运营中心、精细化管理、网格化管理、公安智慧社区管理。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>依托二三维GIS地理信息技术、VR全景技术，做到城市网格之间衔接无缝隙，从而达到管理区域无缝隙。在摸清城市网格内人、事、地、物、情的各类信息情况下，通过各子系统的集成辅助，在日常工作中能实现可视化、精细化管理，实现社会服务管理的及时性、常态化、全天候。将社会问题解决在萌芽状态，降低社会矛盾产生的可能性。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 7" :key="index">
              <img :src="getImg(`application2-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application2",
  metaInfo: {
    title:
      "智慧社区可视化管理_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "智慧社区,智慧社区可视化,三维社区地图,社区三维GIS,智慧社区运维,网格化管理,公安智慧社区,城市运营中心"
      },
      {
        name: "description",
        content:
          "依托二三维GIS地理信息技术、VR全景技术，做到城市网格之间衔接无缝隙，从而达到管理区域无缝隙。在摸清城市网格内人、事、地、物、情的各类信息情况下，通过各子系统的集成辅助，在日常工作中能实现可视化、精细化管理，实现社会服务管理的及时性、常态化、全天候。将社会问题解决在萌芽状态，降低社会矛盾产生的可能性。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧社区可视化管理",
        p:
          "依托二三维GIS地理信息技术、VR全景技术，做到城市网格之间衔接无缝隙，从而达到管理区域无缝隙。在摸清城市网格内人、事、地、物、情的各类信息情况下，通过各子系统的集成辅助……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p:
          "智慧社区、智慧城管、城市运营中心、精细化管理、网格化管理、公安智慧社区管理。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "依托二三维GIS地理信息技术、VR全景技术，做到城市网格之间衔接无缝隙，从而达到管理区域无缝隙。在摸清城市网格内人、事、地、物、情的各类信息情况下，通过各子系统的集成辅助，在日常工作中能实现可视化、精细化管理，实现社会服务管理的及时性、常态化、全天候。将社会问题解决在萌芽状态，降低社会矛盾产生的可能性。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application2 {
  font-size: 0;
  img {
    margin-top: 20px;
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(6),
    &:nth-child(7) {
      width: 584px;
    }
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(5) {
      width: 382px;
    }
    &:nth-child(1),
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(6) {
      margin-right: 20px;
    }
  }
}
.mobile-application2 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application2 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application2 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application2.vue